import type { BlockExportMapping } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { AttachmentBlockExport as AttachmentBlock } from "./AttachmentBlock";
import { DefaultBlock } from "./DefaultBlock";
import { FooterBlock } from "./FooterBlock";
import { ImgBlock } from "./ImgBlock";
import { LineBlock } from "./LineBlock";
import { LinkBlockExport as LinkBlock } from "./LinkBlock";
import { ListBlock } from "./ListBlock";
import { LogoBlock } from "./LogoBlock";
import { PBlock } from "./PBlock";
import { PrimaryButtonBlock } from "./PrimaryButtonBlock";
import { SecondaryButtonBlock } from "./SecondaryButtonBlock";

export const contentBlocks: BlockExportMapping = {
  p: PBlock,
  primaryButton: PrimaryButtonBlock,
  secondaryButton: SecondaryButtonBlock,
  link: LinkBlock,
  img: ImgBlock,
  logo: LogoBlock,
  line: LineBlock,
  list: ListBlock,
  defaultBlock: DefaultBlock,
  footer: FooterBlock,
  attachment: AttachmentBlock,
};
